<template>
  <div class='oversea'>
    <div><img src="/static/images/activty/purchasehistory/purchase_app/app_purchase_01.jpg"></div>
    <div><img src="/static/images/activty/purchasehistory/purchase_app/app_purchase_02.jpg"></div>
    <div><img src="/static/images/activty/purchasehistory/purchase_app/app_purchase_03.jpg"></div>
    <div><img src="/static/images/activty/purchasehistory/purchase_app/app_purchase_04.jpg"></div>
    <div><img src="/static/images/activty/purchasehistory/purchase_app/app_purchase_05.jpg"></div>
    <div><img src="/static/images/activty/purchasehistory/purchase_app/app_purchase_06.jpg"></div>
    <div><img src="/static/images/activty/purchasehistory/purchase_app/app_purchase_07.jpg"><span @click="ShippingFee"></span></div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  data() {
    return {}
  },
  watch: {},
  mounted() {},
  created() {
    this.$store.commit('SET_HEADER_TITLE', this.$t('title.processIntroduction'));
  },
  methods: {
    ShippingFee() {
          this.$router.push({
            path: '/appprocess'
          })
    }
  }
}

</script>
<style scoped>
.oversea img {
  width: 100%;
  display: block;
  overflow: hidden;
}

.oversea>div {
  position: relative;
}

.oversea>div>span {
  position: absolute;
    width: 31vw;
    height: 8vw;
    bottom: 31vw;
    right: 20vw;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/apppurchase.vue